import {
  PanelContainer,
  PanelSeparator,
  openURL,
  useIsDesktop,
  useIsMD,
} from '@eCommerce/frontend-legacy-shared-library-native';
import React from 'react';
import {View} from 'native-base';
import {Image} from 'react-native';
import SectionListItem from 'components/SectionListItem';

import envData from 'env.json';
import {AdobeEvent, useTrackEvent} from 'hooks/useTrackEvent';

const PlanYourStayModule = () => {
  const isMD = useIsMD();
  const isDesktop = useIsDesktop();
  const {API_URL} = envData;
  const {trackAdobeEvent} = useTrackEvent();

  return (
    <>
      <PanelContainer
        panelTitle="Book your stay"
        icon="calendar-alt"
        primaryCTA={{
          label: 'Start booking',
          onPress: () => {
            trackAdobeEvent({
              event: AdobeEvent.click,
              click: {
                name: 'my rewards home start booking ',
              },
            });
            openURL(`${API_URL}/book/`);
          },
        }}
        contentMaxWidth="100%">
        <View
          pt="16px"
          flexDirection={isMD ? 'row' : 'column'}
          alignItems={isMD ? undefined : 'center'}>
          <Image
            style={{
              height: isDesktop ? 231 : 232,
              width: isDesktop ? 284 : 286,
            }}
            source={require('../../assets/room.jpg')}
            alt="An image of a hotel room facing towards the window with two beds and standard hotel furnishings. Outside the window the sky is blue and there are some buildings."
          />

          <View
            ml={isMD ? '48px' : undefined}
            mt={isMD ? undefined : '24px'}
            flex={1}>
            <SectionListItem
              icon="tag"
              title="Members only Pricing & Benefits"
              description="Enjoy exclusive member pricing and earn credits with Caesars Rewards."
            />
            <SectionListItem
              icon="check-circle"
              title="Best Rate Guarantee"
              description="Got a lower rate elsewhere? We'll match it and give 10% more off."
            />
            <SectionListItem
              icon="envelope"
              title="Exclusive Offers"
              description="Subscribe for top rates via our email newsletter."
            />
          </View>
        </View>
      </PanelContainer>
    </>
  );
};

export default PlanYourStayModule;
